module.exports = __webpack_public_path__ + "img/img01.f837367a.png";